import React, { Fragment } from "react";
import { useSelector } from "react-redux";
import { NavItem } from "reactstrap";
import { accountApiUrl } from "../../store/actions/account.actions";
import { IAccount } from "../../store/models/IAccount";
import { IAccountState } from "../../store/models/IAccountState";
import { IState } from "../../store/models/IState";

/**
 * Used to display the account navigation e.g. provide a signout link when required.
 **/
const AccountNavMenu: React.FC = () => {
    const accountState: IAccountState = useSelector((state: IState) => state.accountState);
    const account: IAccount = accountState?.account;
    const logoutUrl = `${accountApiUrl}logout`;
    
    /**
     * Determines whether to display a logout link if the user has logged in.
     **/
    function getNavItems(): JSX.Element | null {
        if (account?.isAuthenticated && account?.isAuthenticationEnabled) {
            // Logout redirects to the logout controller method.
            return (
                <NavItem>
                    <a className="text-dark nav-link" href={logoutUrl}>Logout</a>
                </NavItem>
            );
        }
        else {
            return null;
        }
    }

    return (
        <Fragment>
            {getNavItems()}
        </Fragment>
    );
}

export default AccountNavMenu;